__turbopack_context__.v({
  "root": "omYwwq_root",
  "shippingLabelFadeIn": "omYwwq_shippingLabelFadeIn",
});
